import { render, staticRenderFns } from "./AssignToClaim.vue?vue&type=template&id=3bbd98cc&"
import script from "./AssignToClaim.vue?vue&type=script&lang=js&"
export * from "./AssignToClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports